import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateHudInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateHudInfo = useCallback(
		(prevState, stream) => {
			const hud = { ...prevState.hud };
			if (stream['/vehicle/velocity'])
				hud.speed = parseInt(getStreamData(stream, '/vehicle/velocity'));
			if (stream['/vehicle/turn_signal'])
				hud.turn_signal = getStreamData(stream, '/vehicle/turn_signal');
			if (stream['/regulation_speed'])
				hud.speed_limit = getStreamData(stream, '/regulation_speed');
			if (stream['/vehicle/wheel_angle'])
				hud.steering_angle = parseFloat(
					-1 * getStreamData(stream, '/vehicle/wheel_angle'),
				).toFixed(2);
			if (stream['/vehicle/pedal']) {
				const pedal = JSON.parse(getStreamData(stream, '/vehicle/pedal'));
				hud.accel = pedal.accel;
				hud.brake = pedal.brake;
			}
			if (stream['/vehicle/traffic_light'])
				hud.traffic_light = getStreamData(stream, '/vehicle/traffic_light');
			if (stream['/vehicle/autonomy_state']) {
				const autonomy = getStreamData(stream, '/vehicle/autonomy_state');
				hud.mode = autonomy === 'autonomous' ? 'AUTONOMOUS' : 'MANUAL';
			}
			if (stream['/avs/mode_indicator']) {
				hud.mode_indicator = getStreamData(stream, '/avs/mode_indicator');
			}
			if (stream['/brain/license_key'])
				hud.license = getStreamData(stream, '/brain/license_key');
			return hud;
		},
		[getStreamData],
	);

	return { updateHudInfo };
};
